module.exports = "/images/avatar-s-23.jpg?f7dd6b8f2eed3d37465eed20cc6fc3dd";